var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.438 2.188H15.75V0.5H14.625V2.188H5.625V0.5H4.5V2.188H2.813C1.262 2.188 0 3.45 0 5.001V17.939C0 19.49 1.262 20.752 2.813 20.752H17.438C18.989 20.752 20.251 19.49 20.251 17.939V7.813V6.688V5C20.25 3.449 18.988 2.188 17.438 2.188ZM19.125 17.938C19.125 18.868 18.368 19.625 17.438 19.625H2.813C1.882 19.625 1.125 18.868 1.125 17.938V7.813H19.125V17.938ZM19.125 6.688H1.125V5C1.125 4.069 1.882 3.312 2.813 3.312H4.501V4.437H5.625V3.313H14.625V4.438H15.75V3.313H17.438C18.368 3.313 19.125 4.069 19.125 5V6.688Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.21650a0e39d768a6e89f9e6bde4b9252.svg";
export { ForwardRef as ReactComponent };